import React, { useContext, useEffect } from "react";
import "./last-frame.scss";
import ShowContainer from "../../../../../mui/ShowContainer";
import Spinner from "../../../../../mui/Spinner";
import { LastFrameContext, ZoomContextRef } from "../../../../../../pages/CurrentModel.jsx";
import { useAppSelector } from "../../../../../../store/index.ts";
import { isImageBlank } from "../../../../../../utils/utils.js";
import { setLastFrame } from "../../../../../../store/commonSlice.js";
import { useDispatch } from "react-redux";

export default function LastFrame({ loader }) {
  const lastFrameRef = useContext(LastFrameContext);
  const divZoomRef = useContext(ZoomContextRef);
  const dispatch = useDispatch();
  const lastFrame = useAppSelector((state) => state.common.lastFrame);
  const broadcaster = useAppSelector((state) => state.chat.broadcaster);
  const preview = broadcaster?.chat?.preview;

  const isShow = loader;

  // const lastCanvasWidth = useRef(0);
  // const lastCanvasHeight = useRef(0);
  // const canvasWidth = lastFrameRef.current?.clientWidth || lastCanvasWidth.current;
  // const canvasHeight = lastFrameRef.current?.clientHeight || lastCanvasHeight.current;
  // lastCanvasWidth.current = canvasWidth;
  // lastCanvasHeight.current = canvasHeight;
  // const canvasLeft = canvasWidth ? `calc( (100% - ${canvasWidth}px ) / 2  )` : undefined;
  // const canvasTop = canvasWidth ? `calc( (100% - ${canvasHeight}px ) / 2  )` : undefined;

  const spinnerClass = lastFrame ? "opacity" : "";

  // const canvasStyle = { left: canvasLeft, top: canvasTop, opacity: isShow ? 1 : 0 };
  const canvasStyle = { left: 0, top: 0, opacity: isShow ? 1 : 0 };

  useEffect(() => {
    const canvas = lastFrameRef.current;
    if (!isImageBlank(canvas)) return;

    const ctx = canvas.getContext("2d");
    const img = new Image();

    // const imgOnload = ()

    img.onload = () => {
      const container = divZoomRef.current;
      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;

      if (!containerWidth) return;
      if (!containerHeight) return;
      if (lastFrame) return;

      // Установим canvas под размеры контейнера
      canvas.width = containerWidth;
      canvas.height = containerHeight;

      const imgAspect = img.width / img.height;
      const containerAspect = containerWidth / containerHeight;

      let drawWidth, drawHeight;

      if (imgAspect > containerAspect) {
        drawWidth = containerWidth;
        drawHeight = containerWidth / imgAspect;
      } else {
        drawHeight = containerHeight;
        drawWidth = containerHeight * imgAspect;
      }

      const offsetX = (containerWidth - drawWidth) / 2;
      const offsetY = (containerHeight - drawHeight) / 2;

      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      dispatch(setLastFrame(img));
    };

    img.src = preview;
  }, [preview, lastFrame, isShow]);

  return (
    <>
      <canvas className="last-frame-video__canvas" style={canvasStyle} ref={lastFrameRef} />
      <ShowContainer condition={isShow}>
        <Spinner className={`last-frame-video__spinner ${spinnerClass}`} />
      </ShowContainer>
    </>
  );
}
